<template>
	<v-toolbar id="core-toolbar" dark style="background: #2ec4b6;" flat prominent>
            <!-- <v-toolbar-title class="font-weight-light text-general">
				<p class="toolbar-title">{{ $t('toolbar.title') }}</p>
			</v-toolbar-title>  -->
		<v-spacer/>
		<v-toolbar-items>
			<v-flex align-center layout py-2>
				<!-- <div class="locale-changer"> -->
                    <!-- <language-switcher></language-switcher> -->
					<!-- <select v-model="$i18n.locale">
					<option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
					</select> -->
				<!-- </div> -->
				<!-- <router-link v-ripple class="toolbar-items" to="/dashboard/user-profile">
					<v-icon color>mdi-account</v-icon>
				</router-link> -->
				<v-icon class="toolbar-items" color @click="logout()" :title="$t('logout')">mdi-power</v-icon>
			</v-flex>
		</v-toolbar-items>
	</v-toolbar>
</template>

<script>
import i18n from '../../i18n'
// import LanguageSwitcherVue from '../utils/LanguageSwitcher.vue';
export default {
    name: 'locale-changer',
    data: () => ({  
        langs: ['en', 'sr'] 
    }),
    methods:{
        setLocale(locale){
            this.$i18n.locale = locale;
            this.isActive != this.isActive;
            this.$router.push({
                params: { lang: locale }
            })
        },
        logout(){
            if (confirm(i18n.t('logoutQuestion'))) {
                this.$store.dispatch('AUTH_LOGOUT')
                    .then(() => {
                        this.$router.push(`/${i18n.locale}/account/login`)
                })
            }   
        }
    },
    // components: {
    //     'language-switcher': LanguageSwitcherVue
    // },
}
</script>

<style lang="less">
    #core-toolbar{
        height: 100px !important;
        .v-toolbar__content{
            height: inherit !important;
            padding: 0px 70px 0px 0px !important;
        }
    }

    .locale-changer{
        background: #fff;
        padding: 0px 2px;
        border-radius: 2px;
        margin-right: 15px;
        select{
            cursor: pointer;
        }
    }
</style>